import { useContext } from 'react';

import { EditorContextPanelContext } from '@confluence/editor-context-panel/entry-points/EditorContextPanelContext.ts';
import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';

import { SnippetEditorModal } from '../modals/SnippetEditorModal.tsx';
import { DeleteSnippetModal } from '../modals/DeleteSnippetModal.tsx';
import { SnippetEditorModalMode, type Snippet } from '../snippetTypes.ts';

export type SnippetActionHandlersOptions = {
	onEdit?: (snippet: Snippet) => void;
	onDuplicate?: (snippet: Snippet) => void;
	onDelete?: (snippet: Snippet) => void;
};

export const useSnippetActionHandlers = (options: SnippetActionHandlersOptions = {}) => {
	const { onDuplicate, onDelete } = options;
	const { showModal } = useDialogs();
	const { editorAPI } = useContext(EditorContextPanelContext);

	const handleEdit = (snippet: Snippet) => {
		showModal(SnippetEditorModal, {
			mode: SnippetEditorModalMode.EDIT,
			snippet,
			editorAPI,
		});
	};

	const handleDuplicate = (snippet: Snippet) => {
		// TODO: Implement duplicate (e.g. open duplicate modal or inline flow)
		onDuplicate?.(snippet);
	};

	const handleDelete = (snippet: Snippet) => {
		if (onDelete) {
			onDelete(snippet);
		} else {
			showModal(DeleteSnippetModal, { snippet });
		}
	};

	return { handleEdit, handleDuplicate, handleDelete };
};
